import { ContentBlock } from '../types/api'

// Тестовые видео блоки для проверки KinescopePlayer
export const TEST_VIDEO_BLOCKS: ContentBlock[] = [
  {
    id: 'test-kinescope-1',
    type: 'embed',
    data: {
      embed: 'https://kinescope.io/embed/123456789?autoplay=1&muted=1',
      width: 100,
      height: 400,
      source: 'kinescope',
      caption: 'Тестовое видео Kinescope #1 - Полноэкранный режим для Android',
      service: 'kinescope'
    }
  },
  {
    id: 'test-kinescope-2', 
    type: 'embed',
    data: {
      embed: 'https://kinescope.ru/embed/987654321?autoplay=0&controls=1',
      width: 100,
      height: 300,
      source: 'kinescope',
      caption: 'Тестовое видео Kinescope #2 - С элементами управления',
      service: 'kinescope'
    }
  },
  {
    id: 'test-header-youtube',
    type: 'header',
    data: {
      text: '🎬 YouTube видео (обычный iframe)',
      level: 3
    }
  },
  {
    id: 'test-paragraph-youtube', 
    type: 'paragraph',
    data: {
      text: 'Эти видео отображаются как стандартный iframe без дополнительных кнопок полноэкранного режима.',
      alignment: 'left'
    }
  },
  {
    id: 'test-youtube-1',
    type: 'embed', 
    data: {
      embed: 'https://www.youtube.com/embed/DRYQzS90SAU?si=QX4WF4yz6nOAC929',
      width: 100,
      height: 350,
      source: 'youtube',
      caption: 'Тестовое YouTube видео #1 - обычный iframe (без кнопки полноэкранного режима)',
      service: 'youtube'
    }
  },
  {
    id: 'test-youtube-2',
    type: 'embed', 
    data: {
      embed: 'https://www.youtube.com/embed/DRYQzS90SAU?si=QX4WF4yz6nOAC929&autoplay=0&controls=1',
      width: 100,
      height: 300,
      source: 'youtube',
      caption: 'Тестовое YouTube видео #2 - с элементами управления',
      service: 'youtube'
    }
  },
  {
    id: 'test-header-kinescope',
    type: 'header',
    data: {
      text: '📱 Kinescope видео (с полноэкранным режимом)',
      level: 3
    }
  },
  {
    id: 'test-paragraph-kinescope', 
    type: 'paragraph',
    data: {
      text: 'Эти видео должны отображать кнопку полноэкранного режима в правом верхнем углу. Кнопка работает на всех платформах в тестовом режиме.',
      alignment: 'left'
    }
  },
]

// Реальное тестовое видео Kinescope
export const REAL_KINESCOPE_VIDEOS: ContentBlock[] = [
  {
    id: 'real-kinescope-demo-1',
    type: 'embed',
    data: {
      embed: 'https://kinescope.io/embed/202134398?autoplay=0&muted=0&controls=1',
      width: 100,
      height: 400,
      source: 'kinescope',
      caption: 'Демо видео Kinescope #1 - тест полноэкранного режима',
      service: 'kinescope'
    }
  },
  {
    id: 'real-kinescope-demo-2',
    type: 'embed',
    data: {
      embed: 'https://kinescope.io/embed/201998639?autoplay=0&controls=1&loop=0',
      width: 100,
      height: 350,
      source: 'kinescope',
      caption: 'Демо видео Kinescope #2 - с элементами управления',
      service: 'kinescope'
    }
  }
]
